import {
  mapArrayField,
  mapDateField,
  mapObjectField,
} from "~/v2/mappers/vaas-helpers"
import type {
  VaasCourse,
  VaasLessonSummary,
  VaasVersionSummary,
} from "~/v2/types/vaas"

const mapLessonSummary = (lesson: any): VaasLessonSummary => ({
  ...lesson,
  id: lesson?.id ?? lesson?.lesson_id ?? null,
  lesson_id: lesson?.lesson_id ?? lesson?.id ?? null,
  thumbnail: mapObjectField(lesson?.thumbnail),
  updated: mapDateField(lesson?.updated),
})

const mapVersionSummary = (version: any): VaasVersionSummary => ({
  ...version,
  id: version?.id ?? null,
  version: version?.version ?? null,
  updated: mapDateField(version?.updated),
})

const mapVaasCourse = (course: any): VaasCourse | null => {
  if (!course) {
    return null
  }

  return {
    ...course,
    background_image: mapObjectField(course.background_image),
    cover_image: mapObjectField(course.cover_image),
    created: mapDateField(course.created),
    lessons: mapArrayField(course.lessons).map(mapLessonSummary),
    thumbnail: mapObjectField(course.thumbnail),
    updated: mapDateField(course.updated),
    vaas_locations: mapArrayField(course.vaas_locations),
    versions: mapArrayField(course.versions).map(mapVersionSummary),
  }
}

const mapVaasCourseList = (courses: unknown): VaasCourse[] =>
  mapArrayField(courses).map(mapVaasCourse).filter(Boolean) as VaasCourse[]

export { mapVaasCourse, mapVaasCourseList }
